import { normalizeProductRouteValue } from './navigation'
import type { Product } from './types'

/**
 * Confirma se o payload que está em memória ainda pertence à rota de detalhe
 * atual. A listagem pode carregar o produto pai enquanto a URL aponta para uma
 * variação, por isso aceitamos tanto o ID da rota quanto o contexto do pai.
 */
export const productMatchesDetailRoute = (
  product: Pick<
    Product,
    'id' | 'parentProductId' | 'navigationTargetProductId' | 'navigationParentContextId'
  > | null | undefined,
  routeProductId?: string | null,
  parentContextId?: string | null,
) => {
  if (!product) return false

  const routeId = normalizeProductRouteValue(routeProductId)
  const parentId = normalizeProductRouteValue(parentContextId)
  if (!routeId && !parentId) return false

  const productIds = [
    product.id,
    product.parentProductId,
    product.navigationTargetProductId,
    product.navigationParentContextId,
  ]
    .map((value) => normalizeProductRouteValue(value))
    .filter((value): value is string => Boolean(value))

  return productIds.includes(routeId ?? '') || productIds.includes(parentId ?? '')
}

/**
 * Permite manter o detalhe montado quando a URL ganha o contexto `?pai=` da
 * mesma família. A própria tela de detalhe já carrega e troca as variações;
 * buscar o pai novamente nesse momento desmonta a tela e causa um flash.
 */
export const productSupportsDetailParentContext = (
  product: Pick<Product, 'id' | 'parentProductId'> | null | undefined,
  parentContextId?: string | null,
) => {
  if (!product) return false

  const parentId = normalizeProductRouteValue(parentContextId)
  if (!parentId) return false

  return normalizeProductRouteValue(product.id) === parentId
    || normalizeProductRouteValue(product.parentProductId) === parentId
}
